<template>
  <div>
    <van-nav-bar fixed title="预约检车" left-arrow right-text="说明" @click-left="goBack" @click-right="goInfo"/>
    <div class="v_mainBox">
      <div class="van-border-btm">
        <div class="van-lib">
          <span class="van-address">车检站：</span>
          <van-dropdown-menu active-color="#3778d0" class="van-w">
            <van-dropdown-item v-model="stationId" :options="stationList" @change="onDropdownStation"/>
          </van-dropdown-menu>
        </div>
      </div>

      <div class="van-lineAddress" v-if="isStation" @click="goTencentMap">
        <div class="van-addressBox">
          <span class="van-address">地址：</span>
          <span class="van-text">{{ stationObject.address }} </span>
        </div>
        <i class="van-icon van-icon-location-o address-icon"></i>
      </div>
      <div v-if="isStation">
        <div class="van-phoneBox" v-for="item in (stationObject.tel === null ? 0 :stationObject.tel.split(','))"
             :key="item">
          <div class="van-addressBox">
            <span class="van-address">电话：</span>
            <span class="van-text">
            <a :href="'tel:'+item"><i class="van-icon van-icon-phone-o van-phone"><!----></i></a>
            <a class="tel" :href="'tel:'+item">{{ item }}</a>
          </span>
          </div>
        </div>
      </div>
      <div v-if="isStation" style="border-bottom: 5px solid #eee;">
        <div style="width: 93%;margin: auto;height: 45px;line-height: 45px;font-size: 14px;">
          <span style="width: 5.3em;float: left;">费用：</span>
<!--          <span v-if="stationId==2" style="text-decoration: line-through;">¥260</span>-->
<!--          <span v-if="stationId==2" style="color: red;margin-left: 7px;font-size: 16px;">¥{{totalCost}}</span>-->
          <span style="color: #3778d0;">{{totalCost}}元</span>
        </div>
      </div>

      <van-field required v-model="orderInfo.name" label="姓名：" maxlength="11"
                 placeholder="检车人姓名"
                 name="检车人姓名"/>
      <van-field required v-model="orderInfo.tel" label="电话：" type="tel" maxlength="11"
                 placeholder="请输入电话"
                 name="电话号码"/>
      <van-field readonly clickable required name="预约时间"
                 :value="orderInfo.appointment" label="时间：" placeholder="预约时间"
                 @click="showPicker2 = true" :rules="[{ validator, message: '请输入正确内容' }]"/>
      <van-popup v-model="showPicker2" position="bottom">
        <van-datetime-picker type="datehour" @confirm="onDateConfirm2"
                             :min-date="minDate1" title="选择年月日时分" @cancel="showPicker2 = false"/>
      </van-popup>

<!--      <div class="my-coupon" v-if="isStation">
        &lt;!&ndash; 优惠券单元格 &ndash;&gt;
        <van-coupon-cell
            :coupons="coupons"
            :chosen-coupon="chosenCoupon"
            @click="showList = true"
            style="margin-left: 11px;"
        />
        &lt;!&ndash; 优惠券列表 &ndash;&gt;
        <van-popup
            v-model="showList"
            round
            position="bottom"
            style="height: 90%; padding-top: 4px;"
        >
          <van-coupon-list
              :coupons="coupons"
              :chosen-coupon="chosenCoupon"
              :disabled-coupons="disabledCoupons"
              @change="onChangeCoupon"
              @exchange="onExchangeCoupon"
          />
        </van-popup>
      </div>-->


      <!--  历史记录  -->
      <van-collapse v-model="activeNames" class="van-bottonLine">
        <van-collapse-item>
          <template #title>
            <div>历史预约车辆列表</div>
          </template>
          <van-list>
            <van-cell v-for="(item,index) in vehicleLicenseList" :key="index">
              <p class="van-l">
                <span class="van-cp">{{ item.plateNo }}</span>
                <span class="van-bs">{{ item.vin }}</span>
                <van-button class="van-an" type="primary" size="normal" @click="goSuccessOrder(item)">选择</van-button>
              </p>
            </van-cell>
          </van-list>
        </van-collapse-item>
      </van-collapse>

      <!-- 填单滑动   -->
      <!-- 注意事项tab切换   -->
      <div class="v_tabs">
        <van-tabs v-model="active" swipeable @change="onVanTab">
          <van-tab v-for="(item,index) in tabs" :key="index" :title="item">
            <div v-if="index ===0 ">
              <h4 class="van-title">推荐：拍照行驶证(正照)自动录入信息</h4>
              <div class="van-box">
                <p>1.照片为行驶证正本</p>
                <p>2.照片必须清晰可见</p>
                <p>3.信息可以手动更正</p>
              </div>
              <div class="van-imgBox">
                <van-image fit="fill" width="70%" height="60%" src="images/sm.png"/>
              </div>
              <div style="text-align: center;padding: 10px">
                <van-uploader accept="image/*" :max-count="1" :after-read="upVehicleLicenseImgOCR">
                  <van-button icon="plus" type="primary">上传文件</van-button>
                </van-uploader>
              </div>
            </div>
            <div v-if="index ===1 ">
              <div class="van-lineBox">
                <van-form @submit="onSubmit" @failed="onFailed">

                  <van-field required v-model="carInspectionVehicleLicenseData.plateNo" label="车牌号码："
                             placeholder="请输入车牌号"
                             name="车牌号码"
                             :rules="[{ validator:validatorPlateNo, message: '请输入正确内容' }]"/>
                  <van-field required v-model="carInspectionVehicleLicenseData.vehicleType" label="车辆类型："
                             placeholder="请输入车辆类型"
                             name="车辆类型"
                             :rules="[{ validator, message: '请输入正确内容' }]"/>
                  <van-field required v-model="carInspectionVehicleLicenseData.owner" label="所有人：" placeholder="请输入所有人"
                             name="所有人"
                             :rules="[{ validator, message: '请输入正确内容' }]"/>
                  <van-field required v-model="carInspectionVehicleLicenseData.address" label="住址：" placeholder="请输入住址"
                             name="住址"
                             :rules="[{ validator, message: '请输入正确内容' }]"/>
                  <van-field required v-model="carInspectionVehicleLicenseData.useCharacter" label="使用性质："
                             placeholder="请输入使用性质"
                             name="使用性质"
                             :rules="[{ validator, message: '请输入正确内容' }]"/>
                  <van-field required v-model="carInspectionVehicleLicenseData.model" label="品牌类型："
                             placeholder="请输入品牌类型"
                             name="品牌类型"
                             :rules="[{ validator, message: '请输入正确内容' }]"/>
                  <van-field required v-model="carInspectionVehicleLicenseData.vin" label="识别代码："
                             placeholder="请输入车辆识别代码"
                             name="车辆识别代码"
                             :rules="[{ validator, message: '请输入正确内容' }]"/>
                  <van-field required v-model="carInspectionVehicleLicenseData.engineNo" label="发动机号码："
                             placeholder="请输入发动机号码"
                             name="发动机号码"
                             :rules="[{ validator, message: '请输入正确内容' }]"/>

                  <van-field readonly clickable required name="注册时间"
                             :value="carInspectionVehicleLicenseData.registerDate" label="注册时间" placeholder="注册时间"
                             @click="showPicker = true" :rules="[{ validator, message: '请输入正确内容' }]"/>
                  <van-popup v-model="showPicker" position="bottom">
                    <van-datetime-picker type="date" @confirm="onDateConfirm" title="选择年月日" :min-date="minDate"
                                         :max-date="maxDate" @cancel="showPicker = false"/>
                  </van-popup>

                  <van-field readonly clickable required name="发证时间" :value="carInspectionVehicleLicenseData.issueDate"
                             label="发证时间" placeholder="发证时间" @click="showPicker1 = true"
                             :rules="[{ validator, message: '请输入正确内容' }]"/>
                  <van-popup v-model="showPicker1" position="bottom">
                    <van-datetime-picker type="date" @confirm="onDateConfirm1" title="选择年月日" :min-date="minDate"
                                         :max-date="maxDate" @cancel="showPicker1 = false"/>
                  </van-popup>
                  <van-field required v-model="carInspectionVehicleLicenseData.seal" label="印章：" placeholder="请输入印章"
                             name="印章"
                             :rules="[{ validator, message: '请输入正确内容' }]"/>
                  <van-field readonly name="是否违章" label="是否违章" :rules="[{ validator, message: '请输入正确内容' }]">
                    <template #input>
                      <van-switch v-model="carInspectionVehicleLicenseData.isViolation" size="20"/>
                    </template>
                  </van-field>
                  <!-- 行驶证正面  -->
                  <div class="van-imgUpdata">
                    <h4 class="van-imgTit">上传行驶证照片(必须材料)</h4>
                    <div class="van-put">
                      <van-uploader v-model="vehicleLicenseImg" accept="image/*" :max-count="1"
                                    :after-read="upVehicleLicenseImg">
                        <i class="van-icon van-icon-photograph"></i>
                        <p type="primary" class="clickUpload">上传行驶证正照</p>
                        <van-image class="van-mh" fit="fill" width="100%" height="100" src="images/zhen.jpg"/>
                      </van-uploader>
                    </div>
                    <div class="van-rliz">
                      <span class="text"><van-image fit="fill" src="images/yb.png"/></span>
                      <span class="van-mg"><van-image fit="fill" width="100%" height="100" :src="imagesXc"
                                                      @click="onChange(imagesXc)"/></span>
                    </div>
                  </div>
                  <!-- 行驶证副页  -->
                  <div class="van-imgUpdata van-borderLine">
                    <div class="van-put">
                      <van-uploader v-model="vehicleLicenseImgBack" accept="image/*" :max-count="1"
                                    :after-read="upVehicleLicenseImgBack">
                        <i class="van-icon van-icon-photograph"></i>
                        <p type="primary" class="clickUpload">上传行驶证副照</p>
                        <van-image class="van-mh" fit="fill" width="100%" height="100" src="images/fuy.jpg"/>
                      </van-uploader>
                    </div>
                    <div class="van-rliz">
                      <span class="text"><van-image fit="fill" src="images/yb.png"/></span>
                      <span class="van-mg"><van-image fit="fill" width="100%" height="100" :src="imagesFy"
                                                      @click="onChange(imagesFy)"/></span>
                    </div>
                  </div>
                  <!-- 保险单  -->
                  <div class="van-imgUpdata van-borderLine van-mar">
                    <h4 class="van-imgTit">上传强险保险单照片(可选)</h4>
                    <div class="van-put">
                      <van-uploader v-model="compulsoryInsuranceImg" accept="image/*"
                                    :max-count="1" :after-read="upCompulsoryInsurance">
                        <i class="van-icon van-icon-photograph"></i>
                        <p type="primary" class="clickUpload">上传强险保险单</p>
                        <van-image class="van-mh" fit="fill" width="100%" height="100" src="images/bx.jpg"/>
                      </van-uploader>
                    </div>
                    <div class="van-rliz">
                      <span class="text"><van-image fit="fill" src="images/yb.png"/></span>
                      <span class="van-mg"><van-image fit="fill" width="100%" height="100" :src="imagesBx"
                                                      @click="onChange(imagesBx)"/></span>
                    </div>
                  </div>

                  <!-- 提交订单 -->
                  <van-submit-bar :price="totalCost*100" button-text="提交订单" @submit="onSubmit" :style="{ position: 'fixed',zIndex:10000,borderTop: '2px solid #e4e7ed'}">
                    <template #default>
                      <van-tag type="primary" round color="#BBBDC1" size="medium" @click="isOrderShow = !isOrderShow">明细</van-tag>
                    </template>
                  </van-submit-bar>

                </van-form>
              </div>
            </div>
            <div v-if="index ===2 ">
              <div class="box" v-for="(item,index) in comments_list" :key="index">
                <div class="van-pl">
                  <div class="van-plTitle">
                    <p class="p_one">
                      <span class="span-img"><van-image
                          :src="item.carInspectionComment.avatarName == null ? item.carInspectionComment.avatarName :
                           item.carInspectionComment.avatarName.indexOf('http') !== -1 ? item.carInspectionComment.avatarName :
                            baseApi + '/avatar/' + item.carInspectionComment.avatarName"/></span>
                      <span class="span1">{{ item.carInspectionComment.nickName }}</span>
                      <span class="span2">{{ item.carInspectionComment.reservationType }}</span>
                    </p>
                    <p class=" van-padding">
                      <van-rate v-model="item.carInspectionComment.star" :size="16" color="#ee0a24" void-icon="star"
                                void-color="#eee"/>
                    </p>
                    <p class="van-cData van-padding">{{ item.carInspectionComment.createTime }}</p>

                  </div>
                  <div class="van-inforT">
                    <p class="van-padding">{{ item.carInspectionComment.content }}</p>
                  </div>
                  <div class="van-inforImg mui-content-padded van-padding">
                    <span
                        v-for="item in (item.carInspectionComment.imgs === null ? 0 :item.carInspectionComment.imgs.split(','))"
                        :key="item.images" :title="item">
                      <van-image height="90px" fit="cover" :src="baseApi + '/file/' + item"
                                 @click="onPreviewImg(item)"/>
                    </span>
                  </div>
                  <div class="van-kf" v-for="mm in item.reply" :key="mm.id">
                    <p class="van-titleH van-padding">{{ mm.nickName }}回复：</p>
                    <p class="van-hf van-padding">{{ mm.content }}</p>
                  </div>
                </div>
              </div>
              <van-button v-if="isMoreShow" :loading="loading" type="primary" block loading-text="加载中..."
                          @click="onLoad">
                加载更多
              </van-button>
              <van-divider v-if="!isMoreShow">没有更多了</van-divider>
            </div>
          </van-tab>
        </van-tabs>
      </div>
    </div>
    <van-image-preview v-model="imgShow" :images="images"></van-image-preview>
    <van-overlay :show="show">
      <div class="wrapper">
        <van-loading color="#1989fa" size="40px"><span style="color: #1989fa;font-size: 30px">识别中...</span>
        </van-loading>
      </div>
    </van-overlay>

    <van-image-preview v-model="imageShow" :images="imageList"></van-image-preview>

    <van-popup v-model="isOrderShow" closeable close-icon="close" round position="bottom" :style="{ height: '40%',zIndex:900 }" >
      <div style="text-align: center;font-size: 20px;margin-top: 14px;color:#303133;font-weight: bold;">订单明细</div>
      <div style="padding: 21px 23px;">
        <div style="display: flex;justify-content: space-between;margin-bottom: 12px;">
          <div>平台预约服务费</div>
          <div>￥{{platFee}}</div>
        </div>
        <van-divider />
        <div style="display: flex;justify-content: space-between;margin-bottom: 12px;">
          <div>检车费</div>
          <div style="">￥{{vehicleFee}}</div>
        </div>
        <van-divider />
        <div style="display: flex;justify-content: space-between;">
          <div>总价</div>
          <div>￥{{totalCost}}</div>
        </div>
        <van-divider />
      </div>
    </van-popup>

    <van-overlay :show="showOverlay" :lock-scroll="false" @click="clickOverlay()" z-index="10">
      <green-tips :tipsData="tipsData" style="height: 100%;overflow-y: scroll"></green-tips>
    </van-overlay>
  </div>
</template>

<script type="text/javascript" src="https://res.wx.qq.com/open/js/jweixin-1.6.0.js"></script>
<script>
import carInspectionStation from "@/api/carInspectionStation";
import carInspectionVehicleLicense from "@/api/carInspectionVehicleLicense";
import {baseApi} from "@/utils/auth";
import carInspectionOrder from "@/api/carInspectionOrder";
import carInspectionComment from "@/api/carInspectionComment";
import carInspectionBusiness from "@/api/carInspectionBusiness";
import greenTips from "@/view/inspection/greenTips";
import carInspectionCoupon, {getCouponSends} from "@/api/carInspectionCoupon"

/*const coupon = {
  available: 1,
  condition: '无使用门槛\n最多优惠12元',
  reason: '',
  value: 150,
  name: '优惠券名称',
  startAt: 1489104000,
  endAt: 1514592000,
  valueDesc: '1.5',
  unitDesc: '元',
};*/
export default {
  name: "greenChannel",
  components: {greenTips},
  data() {
    return {
      active: 0,
      //tabar切换
      tabs: ['自动填单', '车辆信息', '车主评价'],
      carInspectionVehicleLicenseData: {},
      showPicker: false,
      showPicker1: false,
      showPicker2: false,
      minDate: new Date(1995, 0, 1),
      maxDate: new Date(),
      minDate1: new Date(),
      vehicleLicenseImg: [],
      vehicleLicenseImgBack: [],
      compulsoryInsuranceImg: [],
      stationId: null,
      stationName: null,
      stationList: [],
      stationObject: {},
      vehicleLicenseList: [],
      // 历史记录折叠面板
      activeNames: [],
      show: false,
      orderInfo: {},
      isStation: false,
      //  评论
      comments_list: [],
      current: 1,
      size: 10,
      total: 0,
      loading: false,
      isMoreShow: true,
      baseApi: baseApi(),
      imgShow: false,
      images: [],
      totlaPrice: 0,
      index: 0,
      imagesXc: 'images/zhen.jpg',
      imagesFy: 'images/fuy.jpg',
      imagesBx: 'images/bx.jpg',
      imageList: [],
      imageShow: false,
      isOrderShow: false,
      platFee: 0,
      vehicleFee: 0,
      totalCost: 0,
      showOverlay: true,
      tipsData: {},
      chosenCoupon: -1,
      coupons: [],
      disabledCoupons: [],
      showList: false
    }
  },
  created() {
    this.getStationAll()
    this.getVehicleLicenseAll()
    this.tipsData = {type: '预约检车'}
    // this.getReservationPrice()
  },
  methods: {
    clickOverlay(){
      this.showOverlay = false
    },
    goBack() {
      if (window.history.length <= 1) {
        this.$router.push({path: '/'})
        return false
      } else {
        this.$router.go(-1)
      }
    },
    goInfo() {
      if(this.stationId === null) {
        this.$toast.fail('请先选择车检站');
      }else{
        // this.getUserCouponList()
        // this.$dialog.alert({
        //   title: '预约检车说明',
        //   messageAlign: 'left',
        //   theme: 'round-button',
        //   message: '\t温馨提示：车型仅支持7座及以下客车，预约检车业务是针对自行到站检车客户提供的线上预约服务。线上预约到站检车的客户可以在各检车站绿色通道办理相关业务，' +
        //       '通过相关信息提前提交和预审核加快检车流程，免除您在窗口排队的烦恼。办理到站检车预约业务需要提前通过彩云通微信公众平台提交姓名、电话、预约检车时间等信息，以及拟检车车辆行驶证信息、' +
        //       '交强险保单照片（可通过拍照行驶证（正照）自动识别录入信息，可省去更多填信息的时间）等车辆相关信息；' +
        //       '此后，工作人员将在后台对您提交的车辆相关信息完整性和准确性进行审核，审核通过后您将收到彩云通发送的审核结果通知以及预约成功的通知。\n'+
        //       '\t收费标准：线上一次性支付包含（平台预约服务费'+this.platFee+'元/次，车辆检测费为'+this.vehicleFee+'元/次）。\n'+
        //       '\t退单收费说明：下单后如需退单将收取平台预约服务费'+this.platFee+'元，车辆检测费'+this.vehicleFee+'元/次全额退款。审核通过后的订单不支持退单。\n'
        // }).then(() => {
        //   // on close
        // });
      }

    },
    /**
     * 样张图片预览
     */
    onChange(img) {
      this.imageShow = true
      this.imageList.length = 0
      this.imageList.push(img)
    },
    /**
     * 获取检车站
     */
    getStationAll() {
      const toast = this.$toast.loading({
        message: '加载中...',
        forbidClick: true,
      });
      this.stationList = []
      this.stationList.length = 0
      this.stationList.push({'text': '请选择车检站', 'value': null})
      carInspectionStation.getAll().then(res => {
        for (let i = 0; i < res.length; i++) {
          let info = {
            text: res[i].station, value: res[i].id,
            lat: res[i].lat, lng: res[i].lng,
            tel: res[i].tel, address: res[i].address
          }
          this.stationList.push(info)
        }
        toast.clear()
      }).catch(err => {
        // eslint-disable-next-line no-console
        console.log(err.data.message)
        toast.clear()
      })
    },
    /**
     * 获取当前用户已审核车辆列表
     */
    getVehicleLicenseAll() {
      this.vehicleLicenseList = []
      this.vehicleLicenseList.length = 0
      carInspectionVehicleLicense.getAll().then(res => {
        this.vehicleLicenseList = res
      }).catch(err => {
        // eslint-disable-next-line no-console
        console.log(err.data.message)
      })
    },
    /**
     * 获取评论
     */
    getCommentList() {
      this.loading = true;
      carInspectionComment.queryPageById({
        'stationId': ((this.stationObject.value === undefined || this.stationObject.value === null) ? 0 : this.stationObject.value),
        'isReview': true,
        'current': this.current,
        'size': this.size
      }).then(res => {
        this.current = res.current
        this.size = res.size
        this.total = res.total
        this.comments_list.push.apply(this.comments_list, res.records)
        this.loading = false;
        if (this.comments_list.length >= this.total) {
          this.isMoreShow = false
        } else {
          this.isMoreShow = true
        }
      }).catch(err => {
        this.loading = false;
        // eslint-disable-next-line no-console
        console.log(err.data.message)
      })
    },
    onVanTab(name) {
      this.comments_list.length = 0
      this.current = 1
      this.total = 0
      switch (name) {
        case 2:
          this.getCommentList()
          break
      }
    },
    goTencentMap() {
      const url = 'https://apis.map.qq.com/tools/poimarker?type=0&marker=coord:' + this.stationObject.lat + ',' + this.stationObject.lng + ';title:' + this.stationObject.text + ';addr:' + this.stationObject.address + '&key=KE2BZ-5CY6W-VRMRT-OCZ63-A7M7O-D4FM2&referer=myapp'
      window.open(url, "_self");
    },
    /**
     * 上传行驶证(自动识别)
     */
    upVehicleLicenseImgOCR(file) {
      this.show = true
      carInspectionVehicleLicense.upVehicleLicenseOCR(file.file).then(res => {
        this.show = false
        this.active = 1
        const VehicleLicenseOCRResponse = res.VehicleLicenseOCRResponse
        this.vehicleLicenseImg.push({'url': baseApi() + '/file/' + res.FileName})

        const FrontInfo = JSON.parse(VehicleLicenseOCRResponse)
        const data = FrontInfo.FrontInfo
        const item = {}
        item.vehicleLicenseImg = res.FileName
        item.plateNo = data.PlateNo
        item.vehicleType = data.VehicleType
        item.owner = data.Owner
        item.address = data.Address
        item.useCharacter = data.UseCharacter
        item.model = data.Model
        item.vin = data.Vin
        item.engineNo = data.EngineNo
        item.registerDate = data.RegisterDate
        item.issueDate = data.IssueDate
        item.seal = data.Seal
        this.carInspectionVehicleLicenseData = {}
        this.carInspectionVehicleLicenseData = Object.assign({}, item)
      }).catch(err => {
        this.show = false
        // eslint-disable-next-line no-console
        console.log(err.data.message)
      })
    },
    /**
     * 上传行驶证（正）
     */
    upVehicleLicenseImg(file) {
      file.status = 'uploading';
      file.message = '上传中...';
      carInspectionVehicleLicense.upVehicleLicense(file.file).then(res => {
        this.carInspectionVehicleLicenseData.vehicleLicenseImg = res
        file.status = '';
        file.message = '';
      }).catch(err => {
        file.status = 'failed';
        file.message = '上传失败';
        // eslint-disable-next-line no-console
        console.log(err.data.message)
      })
    },
    /**
     * 上传行驶证（副）
     */
    upVehicleLicenseImgBack(file) {
      file.status = 'uploading';
      file.message = '上传中...';
      carInspectionVehicleLicense.upVehicleLicenseBack(file.file).then(res => {
        this.carInspectionVehicleLicenseData.vehicleLicenseImgBack = res
        file.status = '';
        file.message = '';
      }).catch(err => {
        file.status = 'failed';
        file.message = '上传失败';
        // eslint-disable-next-line no-console
        console.log(err.data.message)
      })
    },
    /**
     * 上传保险单
     */
    upCompulsoryInsurance(file) {
      file.status = 'uploading';
      file.message = '上传中...';
      carInspectionVehicleLicense.upCompulsoryInsurance(file.file).then(res => {
        this.carInspectionVehicleLicenseData.compulsoryInsuranceImg = res
        file.status = '';
        file.message = '';
      }).catch(err => {
        file.status = 'failed';
        file.message = '上传失败';
        // eslint-disable-next-line no-console
        console.log(err.data.message)
      })
    },
    /**
     * 站点下拉
     */
    onDropdownStation(value) {
      carInspectionBusiness.getByParam({
        'stationId': value,
        'name': '预约检车',
      }).then(res => {
        this.vehicleFee = res.vehicleFee
        this.platFee = res.platFee
        this.totalCost = this.vehicleFee + this.platFee
        this.goInfo()
      }).catch(err => {
        // eslint-disable-next-line no-console
        console.log(err.data.message)
      })


      this.stationObject = {}
      for (let i = 0; i < this.stationList.length; i++) {
        if (this.stationList[i].value === value) {
          this.isStation = true
          this.stationObject = this.stationList[i]
          this.stationName = this.stationList[i].text
          break
        }
      }
      if (this.stationObject.tel === undefined) {
        this.isStation = false
      }
      if (this.active === 2) {
        this.comments_list.length = 0
        this.current = 1
        this.total = 0
        this.getCommentList()
      }
    },
    /**
     * 注册时间
     */
    onDateConfirm(date) {
      this.carInspectionVehicleLicenseData.registerDate = this.dateFormat('YYYY-mm-dd 00:00:00', date)
      this.showPicker = false;
    },
    /**
     * 发证时间
     */
    onDateConfirm1(date) {
      this.carInspectionVehicleLicenseData.issueDate = this.dateFormat('YYYY-mm-dd 00:00:00', date)
      this.showPicker1 = false;
    },
    onDateConfirm2(date) {
      this.orderInfo.appointment = this.dateFormat('YYYY-mm-dd HH:00:00', date)
      this.showPicker2 = false;
    },
    /**
     * 表单校验成功
     */
    onSubmit() {
      if (this.carInspectionVehicleLicenseData.isViolation === undefined) {
        this.carInspectionVehicleLicenseData.isViolation = false
      }
      if (this.carInspectionVehicleLicenseData.vehicleLicenseImg === undefined) {
        this.$notify({type: 'warning', message: '请先选上传行驶证（正照）'});
        return
      }
      if (this.carInspectionVehicleLicenseData.vehicleLicenseImgBack === undefined) {
        this.$notify({type: 'warning', message: '请先选上传行驶证（副照）'});
        return
      }
      if (this.orderInfo.tel === undefined || this.orderInfo.tel === '') {
        this.$notify({type: 'warning', message: '请先填写电话'});
        return
      } else {
        if (!(/^1[34578]\d{9}$/.test(this.orderInfo.tel))) {
          this.$notify({type: 'warning', message: '请填写正确的电话号码'});
          return
        }
      }
      if (this.orderInfo.appointment === undefined || this.orderInfo.appointment === '') {
        this.$notify({type: 'warning', message: '请先填写预约时间'});
        return
      }
      if (this.orderInfo.name === undefined || this.orderInfo.name === '') {
        this.$notify({type: 'warning', message: '请先填写姓名'});
        return
      }
      if (this.stationId === null) {
        this.$notify({type: 'warning', message: '请先选择检车站'});
      } else {
        this.carInspectionVehicleLicenseData.isCompulsoryInsurance = true
        this.carInspectionVehicleLicenseData.stationId = this.stationId
        carInspectionVehicleLicense.add(this.carInspectionVehicleLicenseData).then(res => {
          this.orderInfo.reservationType = '预约检车'
          this.orderInfo.vehicleLicenseId = res
          this.orderInfo.stationId = this.stationId
          this.orderInfo.carInspectionStation = this.stationName
          this.orderInfo.vehicleFee = this.vehicleFee
          this.orderInfo.platFee = this.platFee
          this.orderInfo.totalCost = this.totalCost
          this.orderInfo.miniprogram = false
          if (window.__wxjs_environment === 'miniprogram'){
            this.orderInfo.miniprogram = true
          }
          this.createOrder(this.orderInfo)
        }).catch(err => {
          // eslint-disable-next-line no-console
          console.log(err.data.message)
        })
      }
    },
    /**
     * 图片预览
     */
    onPreviewImg(imgs) {
      this.images.length = 0
      this.images.push(baseApi() + '/file/' + imgs)
      this.imgShow = true
    },
    /**
     * 历史车辆选择预约点击事件
     */
    goSuccessOrder(item) {
      if (this.orderInfo.tel === undefined || this.orderInfo.tel === '') {
        this.$notify({type: 'warning', message: '请先填写电话'});
        return
      } else {
        if (!(/^1[34578]\d{9}$/.test(this.orderInfo.tel))) {
          this.$notify({type: 'warning', message: '请填写正确的电话号码'});
          return
        }
      }
      if (this.orderInfo.appointment === undefined || this.orderInfo.appointment === '') {
        this.$notify({type: 'warning', message: '请先填写预约时间'});
        return
      }
      if (this.orderInfo.name === undefined || this.orderInfo.name === '') {
        this.$notify({type: 'warning', message: '请先填写姓名'});
        return
      }
      if (this.stationId === null) {
        this.$notify({type: 'warning', message: '请先选择检车站'});
      } else {
        this.orderInfo.reservationType = '预约检车'
        this.orderInfo.vehicleLicenseId = item.id
        this.orderInfo.stationId = this.stationId
        this.orderInfo.carInspectionStation = this.stationName
        this.orderInfo.vehicleFee = this.vehicleFee
        this.orderInfo.platFee = this.platFee
        this.orderInfo.totalCost = this.totalCost
        this.orderInfo.miniprogram = false
        if (window.__wxjs_environment === 'miniprogram'){
          this.orderInfo.miniprogram = true
        }
        this.createOrder(this.orderInfo)
      }
    },
    /**
     * 获取总价
     */
 /*   getReservationPrice() {
      this.totlaPrice = 0
      dictApi.getReservationPrice().then(res => {
        for (let i = 0; i < res.content.length; i++) {
          this.totlaPrice = this.totlaPrice + parseFloat(res.content[i].value)
        }
      }).catch(err => {
        // eslint-disable-next-line no-console
        console.log(err.data.message)
      })
    },*/
    /**
     * 创建订单
     */
    createOrder(orderInfo) {
      const toast = this.$toast.loading({
        message: '提交中...',
        forbidClick: true,
      });
      carInspectionOrder.add(orderInfo).then(res => {
        toast.clear()
        // eslint-disable-next-line no-console
        window.location.href = res
      }).catch(err => {
        // eslint-disable-next-line no-console
        console.log(err.data.message)
        toast.clear()
      })
    },
    /**
     * 表单校验失败
     * @param errorInfo
     */
    onFailed(errorInfo) {
      // eslint-disable-next-line no-console
      console.log('failed', errorInfo);
      this.$notify({type: 'warning', message: '请检查信息是否填写完整'});
    },
    // 校验函数返回 true 表示校验通过，false 表示不通过
    validator(val) {
      return val !== '';
    },
    validatorPlateNo(val) {
      return /^(([京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领][A-Z](([0-9]{5}[DF])|([DF]([A-HJ-NP-Z0-9])[0-9]{4})))|([京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领][A-Z][A-HJ-NP-Z0-9]{4}[A-HJ-NP-Z0-9挂学警港澳使领]))$/.test(val);
    },
    /**
     * 加载更多评论
     */
    onLoad() {
      this.current = this.current + 1
      this.getCommentList()
    },
    /**
     * 时间格式
     * @param fmt
     * @param date
     * @returns {*}
     */
    dateFormat(fmt, date) {
      let ret;
      const opt = {
        "Y+": date.getFullYear().toString(),        // 年
        "m+": (date.getMonth() + 1).toString(),     // 月
        "d+": date.getDate().toString(),            // 日
        "H+": date.getHours().toString(),           // 时
        "M+": date.getMinutes().toString(),         // 分
        "S+": date.getSeconds().toString()          // 秒
        // 有其他格式化字符需求可以继续添加，必须转化成字符串
      };
      for (let k in opt) {
        ret = new RegExp("(" + k + ")").exec(fmt);
        if (ret) {
          fmt = fmt.replace(ret[1], (ret[1].length === 1) ? (opt[k]) : (opt[k].padStart(ret[1].length, "0")))
        }
      }
      return fmt;
    },
    onChangeCoupon(index) {
      // console.log("选/不选优惠券==="+index)
      this.showList = false;
      this.chosenCoupon = index;
    },
    onExchangeCoupon(code) {
      // console.log("onExchangeCoupon==="+code)
      this.coupons.push(coupon);
    },
    getUserCouponList(){
      carInspectionCoupon.getCouponSends({transactionMinimum: this.totalCost, discountIdOrName: "预约检车"}).then(res => {
       // eslint-disable-next-line no-console
        console.log(JSON.stringify(res))
        for (let i = 0; i < res.length; i++) {
          let info = {
            id: res[i].couponCode, name: res[i].stockName,
            condition: '满'+res[i].transactionMinimum+'优惠'+res[i].discountAmount+'元',
            startAt: new Date(res[i].availableStartTime).getTime()/1000,
            endAt: new Date(res[i].expireTime).getTime()/1000,
            valueDesc: res[i].discountAmount,
            unitDesc: '元',
          }
          this.coupons.push(info)
        }
      }).catch(err => {
        // eslint-disable-next-line no-console
        console.log(err.data.message)
      })
    },


  }
}
</script>

<style scoped>
.v_mainBox {
  width: 100%;
  padding-top: 45px;
}

.van-line {
  width: 100%;
  flex: inherit;
  overflow: hidden;
  height: 45px;
  line-height: 45px;
}

.van-border-btm {
  border-bottom: 1px solid #eee;
}

.van-lib {
  width: 93%;
  margin: auto;
  height: 45px;
  line-height: 45px;
  font-size: 14px
}

.van-line span {
  padding: 0 15px 0 10px;
  display: block;
  float: left;
  font-size: 14px;
}

.van-line .van-pr {
  padding-right: 20px;
}

.van-dropdown-menu {
  box-shadow: none;
  overflow: hidden;
}

.van-cell {
  height: 45px !important;
  line-height: 45px !important;
  padding: 0 !important;
  margin: 0 !important;
  border-bottom: 1px solid #eee;
}

.van-cell::after {
  left: 0 !important;
  right: 0 !important;
  border-bottom: 1px solid #eee;
  transform: inherit;
}

.van-cell--clickable {
  width: 100%;
}

.van-field__label {
  padding-left: 12px
}

.van-icon-arrow::before {
  margin-top: 50%;
}

.van-cell::after {
  border: none;
}

/*检车站地址*/
.van-lineAddress {
  width: 100%;
  height: 45px;
  line-height: 45px;
  overflow: hidden;
  border-bottom: 1px solid #eee
}

.van-addressBox {
  width: 93%;
  margin: auto;
  font-size: 14px;
  height: 45px;
}

.van-address {
  width: 5.3em;
  float: left
}

.van-addressBox .van-text {
  width: 70%;
  height: 45px;
  display: inline-block;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.address-icon {
  font-size: 18px;
  color: #3778d0;
  display: inline-block;
  line-height: 45px;
  right: 0;
  margin-top: -13%;
  position: absolute;
  margin-right: 4%;
}

.van-phone {
  font-size: 22px;
  color: #3778d0;
  height: 45px;
  line-height: 45px;
  display: block;
  float: left;
}

.van-phoneBox {
  width: 100%;
  height: 45px;
  line-height: 45px;
  overflow: hidden;
  border-bottom: 1px solid #eee;
}

.van-bottonLine {
  border-top: 5px solid #eee
}

/*历史记录列表*/
.van-l {
  width: 100%;
  height: 45px;
  line-height: 45px;
  padding: 0 !important;
  margin: 0 !important;
  overflow: hidden
}

.van-l span {
  display: block;
  font-size: 12px;
  float: left;
}

.van-l .van-cp {
  width: 25%
}

.van-l .van-an {
  width: 20%;
  float: right;
  height: 25px;
  line-height: 25px;
  padding: 0;
  margin: 10px 0;
}

.van-button--primary {
  background-color: #3778d0;
  border: 1px solid #3778d0;
}

.v_tabs {
  border-top: 5px solid #eee;
  margin-bottom: 20px;
}

/*自动填单*/
.van-title {
  width: 90%;
  margin: auto;
  height: 55px;
  line-height: 65px;
  text-align: center;
  color: #3778d0;
}

.van-box {
  width: 90%;
  margin: auto;
  height: auto;
  display: block;
}

.van-box p {
  margin: 0;
  padding: 0;
  height: 25px;
  line-height: 25px;
  text-align: center;
  font-size: 13px;
  color: #888;
}

.van-imgBox {
  width: 80%;
  margin: auto;
  height: auto;
  overflow: hidden;
  text-align: center;
  padding-top: 5%;
}

.van-paiButton {
  width: 45%;
  margin-left: 26%;
  margin-top: 10%;
}

/*图片上传*/
.van-imgUpdata {
  width: 100%;
  padding: 0 10px;
  display: block;
  overflow: hidden;
}

.van-borderLine {
  border-bottom: 1px solid #eee;
}

.van-block {
  width: 100%;
  display: block;
  overflow: hidden;
}

.van-imgTit {
  width: 100%;
  height: 35px;
  line-height: 35px;
  font-size: 14px;
  margin: 5px 0;
}

.van-imgTit span {
  color: #888;
  font-size: 13px;
  padding-left: 2%;
  font-weight: 500;
}

.van-put {
  width: 47%;
  float: left;
  height: 100px;
  display: block;
  overflow: hidden;
  margin-bottom: 10px
}

.van-put .van-mh {
  filter: blur(2px);
  border-radius: 3px;
  width: 100%;
}

.van-rliz {
  width: 46%;
  float: left;
  height: 100px;
  display: block;
  overflow: hidden;
  margin-left: 2%;
}

.van-rliz .text {
  display: block;
  position: absolute;
  right: 0;
  margin-right: 2.2%;
  width: 10%;
  height: 5%;
  overflow: hidden;
  z-index: 2;
}

.van-rliz img {
  width: 100%;
  height: 100%;
  border-radius: 3px;
}

.van-icon-photograph {
  font-size: 35px;
  position: absolute;
  z-index: 1;
  color: #666;
  text-align: center;
  width: 100%;
  margin-top: 15%;
}

.clickUpload {
  font-size: 14px;
  position: absolute;
  margin-top: 34%;
  color: #666;
  text-align: center;
  width: 100%;
  z-index: 1;
}

/*评论*/
.box {
  width: 90%;
  margin: auto;
  display: block;
  height: auto;
  border-bottom: 1px solid #eee
}

.van-cell__title{
  margin-left: 11px;
}
.my-coupon .van-cell__right-icon{
  margin-top: -7px;
}

</style>
